module.exports = __webpack_public_path__ + "static/media/main-bg.0f39d3c4.jpg";